<!-- (1.1.16) セグメント情報 (1) -->
<div
  [ngClass]="['p-flight-detail01__block', this.flight.statusCode === 'UN' ? 'p-flight-detail01__block--gray10' : '']"
>
  <asw-departure [boundIdx]="boundIdx" [flightIdx]="flightIdx"></asw-departure>
  <asw-waiting [boundIdx]="boundIdx" [flightIdx]="flightIdx"></asw-waiting>
  <asw-arrival [boundIdx]="boundIdx" [flightIdx]="flightIdx"></asw-arrival>
</div>
